/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { SWITCH_SECTION } from "../graphql/switchSection.mutation";

const is = require("is_js");
export interface ISwitchSectionArgs {
  boxId: string;
  presentationID: string;
  sectionID: string;
  reason: string;
  partition: string;
  items: {
    costumeType: string;
    costumeFeature: string;
    costumeAttribute: string;
    costumeValue: string;
  }[];
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISwitchSectionTypeMethods extends IPluginMethodMap {
  switchSection(args: any): Promise<any>;
}

export class SwitchSectionService implements IAgentPlugin {
  readonly methods: ISwitchSectionTypeMethods;

  constructor() {
    this.methods = {
      switchSection: this.switchSection.bind(this),
    };
  }

  async switchSection(args: ISwitchSectionArgs) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: SWITCH_SECTION,
          variables: {
            data: {
              boxId: args?.boxId,
              presentation: args?.presentationID,
              section: args?.sectionID,
              reason: args?.reason,
              partition: args?.partition,
              items: args?.items,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.switchSection && is.existy(res?.data?.switchSection)) {
          return res?.data?.switchSection;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
